<template>
  <Item
    :isChecked="isChecked"
    :isIndeterminate="isIndeterminate"
    :showCheckbox="showCheckbox"
    :showChevron="showChevron"
    :disableCheck="disableCheck"
    @click="$emit('click', child.id)"
    @check="(checked) => $emit('check', { child, checked })"
  >
    <template #content>
      <div class="flex gap-4 grow items-center justify-between overflow-hidden">
        <span
          class="font-medium text-base truncate text-tertiary"
          v-html="highlight(child.name)"
        >
        </span>
        <Badge
          :variant="
            isChecked || isIndeterminate ? 'identifier-active' : 'identifier'
          "
          class="overflow-hidden max-w-[5rem]"
          v-if="child.identifier"
        >
          <span class="truncate">{{ child.identifier }}</span>
        </Badge>
      </div>
    </template>
  </Item>
</template>

<script setup>
import { Item } from "@/Components/List";
import { Badge } from "@/Shadcn/Components/ui/badge";

defineEmits(["check", "click"]);

const props = defineProps({
  child: Object,
  isIndeterminate: {
    type: Boolean,
    default: false,
  },
  isChecked: {
    type: Boolean,
    default: false,
  },
  showCheckbox: {
    type: Boolean,
    default: false,
  },
  showChevron: {
    type: Boolean,
    default: false,
  },
  searchQuery: {
    type: String,
    required: false,
  },
  disableCheck: {
    type: Boolean,
    default: false,
  },
});

const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

const highlight = (text) => {
  if (!props.searchQuery) {
    return text;
  }
  const searchRegex = new RegExp(`(${escapeRegExp(props.searchQuery)})`, "gi");
  return text.replace(
    searchRegex,
    '<span class="font-bold text-primary">$1</span>'
  );
};
</script>
